<template>
  <div class="reporting">
    <a class="d-back-link" href="/calendar">Tilbage til Docendo</a>
    <div class="reporting__header">
      <div class="reporting__header__right">
        <h1>Grundskoleindberetning</h1>
        <ChangeSchoolYear :whiteTheme="true"></ChangeSchoolYear>
      </div>
      <StilGuides :is-button="true"></StilGuides>
    </div>
    <div v-if="isLoadingStilData || !isUserLoaded" style="width: 500px">
      <Loader></Loader>
    </div>
    <div class="d-form alert" v-if="isUserLoaded && userHasNoEmail">
      <h3>Der skal udfyldes en email for at benytte grundskoleindberetningen</h3>
      <div class="d-input-group">
        <label>Din email</label>
        <input type="text"
               ref="user_email_input"
               v-model.trim="userEmailInput"
               @keyup="removeErrors('email')"
               :class="{'input--error': userEmailFormErrors['email']}">
        <p class="input-error" v-if="userEmailFormErrors['email']">
          {{ $t('vue2.createusers.email_error_text') }}
        </p>
      </div>
      <div class="d-form__submit">
        <button class="bttn submit-button" @click="submitUserEmail"
                :class="[
                    {'bttn--loading': isSavingUserEmail},
                    {'submit-button--disabled': isSaveButtonForUserEmailDisabled}
                    ]">
          {{ $t('vue2.common.save') }}
        </button>
      </div>
    </div>
    <template v-if="isUserLoaded && !isLoadingStilData && !userHasNoEmail">
      <div class="d-tabs">
        <div class="d-tabs__tab" :class="{'d-tabs__tab--active': theActiveTab === 0}" @click="theActiveTab = 0">
          1. Personalets alder og køn
        </div>
        <div class="d-tabs__tab" :class="{'d-tabs__tab--active': theActiveTab === 1}" @click="theActiveTab = 1">
          2. Ressourceforbrug
        </div>
        <div class="d-tabs__tab" :class="{'d-tabs__tab--active': theActiveTab === 2}" @click="theActiveTab = 2">
          3. Antal elever og undervisningstimer
        </div>
        <div class="d-tabs__tab" :class="{'d-tabs__tab--active': theActiveTab === 3}" @click="theActiveTab = 3">
          Resumé og indberetning
        </div>
      </div>
      <div class="reporting-content">
        <div class="reporting__table">
          <GrundskoleIndberetningUsers
            v-if="theActiveTab === 0">
          </GrundskoleIndberetningUsers>
          <GrundskoleIndberetningRessource
            :stilData="stilData"
            @updateStil="updateRessource"
            v-if="theActiveTab === 1">
          </GrundskoleIndberetningRessource>
          <GrundskoleIndberetningTimetal
            v-if="theActiveTab === 2"
            :stilData="stilData"
            @update="update"
            @updateSubject="updateSubject"
            @updateKonfirmation="updateKonfirmation"
            @updatePraktik="updatePraktik"
            @setTolaerer="setTolaerer"
            @setForanstaltning="setForanstaltning"
            @nulstilKlasse="nulstilKlasse">
          </GrundskoleIndberetningTimetal>
          <GrundskoleIndberetningResume
            v-if="theActiveTab === 3">
          </GrundskoleIndberetningResume>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import docendo from '../../docendo.js'
import GrundskoleIndberetningUsers from './GrundskoleIndberetningUsers'
import GrundskoleIndberetningTimetal from './GrundskoleIndberetningTimetal'
import GrundskoleIndberetningRessource from './GrundskoleIndberetningRessource'
import Loader from '../common/Loader'
import ChangeSchoolYear from '../School/ChangeSchoolYear'
import GrundskoleIndberetningResume from './GrundskoleIndberetningResume'
import StilGuides from './StilGuides'
import eventbus from '../../eventbus'

export default {
  components: {
    StilGuides,
    GrundskoleIndberetningResume,
    ChangeSchoolYear,
    Loader, GrundskoleIndberetningUsers, GrundskoleIndberetningTimetal, GrundskoleIndberetningRessource
  },
  data () {
    return {
      theActiveTab: 0,
      stilData: [],
      isLoadingStilData: false,
      userEmailInput: '',
      userEmailFormErrors: {},
      isSavingUserEmail: false
    }
  },
  computed: {
    schoolId () {
      return this.$route.params.school_id
    },
    user () {
      return this.$store.state.user
    },
    isUserLoaded () {
      return this.$store.state.isUserLoaded
    },
    userHasNoEmail () {
      return this.user && this.user.email === null
    },
    isSaveButtonForUserEmailDisabled () {
      return this.userEmailInput.length < 3
    }
  },
  watch: {
    user () {
      if (this.userHasNoEmail) {
        setTimeout(() => {
          const el = this.$refs.user_email_input
          if (el) {
            this.$refs.user_email_input.focus()
          }
        }, 0)
        return
      }
      this.isLoadingStilData = true
      docendo.showStilReport(this.schoolId, success => {
        this.isLoadingStilData = false
        this.stilData = success
      }, failure => {
        console.log('failure')
      })
    }
  },
  methods: {
    updateRessource (ressourceSkema) {
      let stilData = JSON.parse(JSON.stringify(this.stilData))
      stilData['ressourceskema'] = ressourceSkema
      docendo.updateStilReport(this.schoolId, stilData, success => {
        this.stilData = success
      }, failure => {
        console.log('failure', failure)
      })
    },
    setTolaerer (obj) {
      const setting = obj.godkendelseskode === 'J' ? 'N' : 'J'
      let stilData = JSON.parse(JSON.stringify(this.stilData))
      const idx = stilData['undervisningskema'].findIndex(stilTing => stilTing._type === obj._type && stilTing.klassetype === obj.klassetype && stilTing.godkendelsestype === obj.godkendelsestype && stilTing.klassetrin === obj.klassetrin)
      stilData['undervisningskema'][idx]['godkendelseskode'] = setting
      docendo.updateStilReport(this.schoolId, stilData, success => {
        this.stilData = success
      }, failure => {
        console.log('failure', failure)
      })
    },
    setForanstaltning (obj) {
      const setting = obj.godkendelseskode === 'J' ? 'N' : 'J'
      let stilData = JSON.parse(JSON.stringify(this.stilData))
      const idx = stilData['undervisningskema'].findIndex(stilTing => stilTing._type === obj._type && stilTing.klassetype === obj.klassetype && stilTing.godkendelsestype === obj.godkendelsestype && stilTing.klassetrin === obj.klassetrin)
      stilData['undervisningskema'][idx]['godkendelseskode'] = setting
      docendo.updateStilReport(this.schoolId, stilData, success => {
        this.stilData = success
      }, failure => {
        console.log('failure', failure)
      })
    },
    updatePraktik (obj) {
      const setting = obj.praktikkode === 'J' ? 'N' : 'J'
      let stilData = JSON.parse(JSON.stringify(this.stilData))
      const idx = stilData['undervisningskema'].findIndex(stilTing => stilTing._type === obj.v_fag._type)
      stilData['undervisningskema'][idx]['praktikkode'] = setting
      docendo.updateStilReport(this.schoolId, stilData, success => {
        this.stilData = success
      }, failure => {
        console.log('failure', failure)
      })
    },
    updateKonfirmation (obj) {
      let stilData = JSON.parse(JSON.stringify(this.stilData))
      const idx = stilData['undervisningskema'].findIndex(stilTing => stilTing._type === obj.v_fag._type)
      // stilData['undervisningskema'][idx]['klassetrin'] = stilData['undervisningskema'][idx]['klassetrin'] === obj.value ? '' : obj.value
      stilData['undervisningskema'][idx]['klassetrin'] = obj.value
      docendo.updateStilReport(this.schoolId, stilData, success => {
        this.stilData = success
      }, failure => {
        console.log('failure', failure)
      })
    },
    updateSubject (obj) {
      // const obj = {originalObject, value, toUpdate: 'klokketimer'}
      let stilData = JSON.parse(JSON.stringify(this.stilData))
      const idx = stilData['undervisningskema'].findIndex(stilTing => stilTing._type === obj.originalObject._type && stilTing.klassetype === obj.originalObject.klassetype && stilTing.fagkode === obj.originalObject.fagkode && stilTing.klassetrin === obj.originalObject.klassetrin)
      stilData['undervisningskema'][idx][obj.toUpdate] = obj.value * 1
      docendo.updateStilReport(this.schoolId, stilData, success => {
        this.stilData = success
      }, failure => {
        console.log('failure', failure)
      })
    },
    nulstilKlasse (grade) {
      let stilData = JSON.parse(JSON.stringify(this.stilData))
      const subjects = stilData['undervisningskema'].filter(subject => subject._type === 'undervisningstid' && subject.klassetrin === grade.value * 1)
      subjects.forEach(subject => {
        const idx = stilData['undervisningskema'].findIndex(stilTing => stilTing._type === subject._type && stilTing.klassetype === subject.klassetype && stilTing.fagkode === subject.fagkode && stilTing.klassetrin === subject.klassetrin)
        stilData['undervisningskema'][idx]['klokketimer'] = 0
        docendo.updateStilReport(this.schoolId, stilData, success => {
          this.stilData = success
        }, failure => {
          console.log('failure', failure)
        })
      })
    },
    update (obj) {
      let stilData = JSON.parse(JSON.stringify(this.stilData))
      const idx = stilData[obj.type].findIndex(elevtal => elevtal._type === obj.cell._type && elevtal.elevtaltype === obj.cell.elevtaltype && elevtal.klassetrin === obj.cell.klassetrin)
      stilData[obj.type][idx]['antal'] = obj.num * 1
      docendo.updateStilReport(this.schoolId, stilData, success => {
        this.stilData = success
      }, failure => {
        console.log('failure', failure)
      })
    },
    submitUserEmail () {
      this.formValidation()
      if (Object.keys(this.userEmailFormErrors).length > 0) {
        return
      }
      this.isSavingUserEmail = true
      let changes = {email: this.userEmailInput}
      docendo.updateUser(changes, success => {
        eventbus.toast = {text: 'Emailen er gemt', 'success': true}
        const obj = {
          prop: 'email',
          email: success.email
        }
        this.$store.commit('updateUserProp', obj)
        this.isSavingUserEmail = false
      }, failure => {
        eventbus.toast = {text: 'Email er allerede brugt', 'success': false}
        this.isSavingUserEmail = false
      })
    },
    formValidation () {
      this.userEmailFormErrors = {}
      if (!this.validateEmail(this.userEmailInput)) {
        this.$set(this.userEmailFormErrors, 'email', 'Er ikke en gyldig email')
      }
    },
    validateEmail (email) {
      // Check if the email is not empty and matches the regex pattern
      const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
      return email.trim() !== '' && emailRegex.test(email)
    },
    removeErrors (title) {
      this.$delete(this.userEmailFormErrors, title)
    }
  },
  beforeMount () {
    this.$store.dispatch('getUser')
  },
  mounted () {
    this.$store.dispatch('getUsersFromSchoolId', this.schoolId)
    this.$store.dispatch('readSchoolYears', this.schoolId)
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.reporting {
  margin: 1rem;
}

.reporting__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1440px;
  min-width: 1100px;
}

.reporting__header__right {
  display: flex;
  align-items: center;
}

.reporting__header h1 {
  margin-right: 1rem;
}

.d-tabs {
  display: flex;
  align-items: stretch;
}

.d-tabs__tab {
  border-radius: 4px 4px 0 0;
  padding: 1rem 2rem;
  margin-bottom: -1px;
  margin-right: 0;
  font-weight: bold;
  cursor: pointer;
}

.d-tabs__tab.d-tabs__tab--active {
  border: 1px solid #d8d8d8;
  border-width: 1px 1px 0 1px;
  color: var(--primary);
}

.d-table thead th.d-table__cell__input__number {
  text-align: center;
}

.d-back-link:hover {
  text-decoration: underline;
}

.alert {
  font-weight: normal;
  border: 1px solid #facc17;
  border-radius: 4px;
  background-color: #fefce8;
  padding: 0.5rem;
  margin-bottom: 1rem;
  font-size: 11px;
  line-height: 1.5;
  color: #a26206;
  max-width: 600px;
}

.alert .d-input-group {
  margin: 0;
  padding: 0;
}

.alert label {
  text-transform: initial;
  font-size: 11px;
  line-height: 1.2 !important;
  color: #a26206 !important;
  letter-spacing: 0 !important;
}

.d-form {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  gap: 1rem;
}

.d-form__submit {
  display: flex;
  justify-content: flex-end;
}

.d-form__submit .submit-button {
  width: 100px;
}

</style>



// WEBPACK FOOTER //
// GrundskoleIndberetning.vue?b2a909a8